module.exports = __webpack_public_path__ + "img/ico_tab1_account2@3x.f17e738a.png";